module.exports = __webpack_public_path__ + "img/C108.510dec53.jpg";